export default "__VITE_ASSET__xzZD8RU0__"